import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';

import { CoreInsightsEvent, InsightsContextAware } from '@core/shared/util';

@Component({
  selector: 'mp-navigation-profile',
  templateUrl: './navigation-profile.component.html',
  styleUrl: './navigation-profile.component.scss',
  host: {
    '[class]': 'class()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, MatIconButton, MatIcon, MatMenu, MatMenuTrigger, MatMenuItem],
})
export class NavigationProfileComponent extends InsightsContextAware {
  private readonly router: Router = inject(Router);

  private readonly componentCssClass = 'mp-navigation-profile';

  readonly path: InputSignal<string> = input.required<string>();
  readonly user: InputSignal<string | null | undefined> = input<string | null>();
  readonly organization: InputSignal<string | null | undefined> = input<string | null>();
  readonly image: InputSignal<string | null | undefined> = input<string | null>();

  readonly size: InputSignal<'small' | 'large'> = input<'small' | 'large'>('large');

  readonly logout: OutputEmitterRef<void> = output<void>();

  protected readonly class: Signal<string> = computed(() => {
    return `${this.componentCssClass} ${this.componentCssClass}--${this.size()}`;
  });

  protected trackProfileNavigation(): void {
    if (!this.isActive()) {
      this.trackInsightsEvent(CoreInsightsEvent.PROFILE_EDIT_PAGE_NAVIGATION);
    }
  }

  protected trackManageAccountClick(): void {
    this.trackInsightsEvent(CoreInsightsEvent.ACCOUNT_MANAGEMENT_BUTTON_CLICK);
  }

  protected handleLogout(): void {
    this.trackInsightsEvent(CoreInsightsEvent.ACCOUNT_MANAGEMENT_BUTTON_LOGOUT);
    this.logout.emit();
  }

  override trackInsightsEvent(event: CoreInsightsEvent): void {
    super.trackInsightsEvent(event, {}, { includePageName: false });
  }

  private isActive(): boolean {
    return this.router.isActive(this.path(), {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
